import styled from "styled-components";
import { FaAngleDown } from "react-icons/fa";

export const DashboardContainer = styled.div`
  min-height: 93vh;
  width: 100%;
  background: -webkit-linear-gradient(to right, #243b55, #141e30);
  background: linear-gradient(to right, #243b55, #141e30);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (max-width: 968px) {
    height: 100%;
  }
`;

export const DashboardWrapper = styled.div`
  display: flex;
  margin: 5rem auto;
  height: 100%;
  width: 90%;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.23);
  backdrop-filter: blur(20px);
  border-radius: 10px;
  box-shadow: 0 0 10px -2px rgba(0, 0, 0, 0.5);
`;

export const DashboardMain = styled.div`
  display: flex;
  height: 100%;
  width: 100%;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
`;

export const DashboardCards = styled.section`
  display: flex;
  align-items: center;
  width: 70%;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 425px) {
    flex-direction: column;
  }
`;

export const DashboardColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const DashboardRow = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const DashboardCard = styled.div`
  flex: 1;
  flex-grow: 1;
  margin: 1rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 15px -2px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.23);
  cursor: pointer;
`;

export const DashboardHeader = styled.div`
  padding: 1rem 0 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & h1 {
    color: #eee;
  }
  & span {
    color: #ddd;
    font-size: 1.5rem;
    font-weight: normal;
  }
`;

export const DashboardAside = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const AsideWrapper = styled.aside`
  margin: 1rem;
  width: 80%;
  height: 90%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 10px;
  padding: 1rem 0;
`;

export const AsideHeader = styled.div`
  display: flex;
  padding: 1rem 0;
  width: 90%;
  border-radius: 10px;
  justify-content: center;
  box-shadow: 0 0 10px -2px rgba(0, 0, 0, 0.5);

  & h3 {
    color: rgba(155, 155, 155);
  }
`;

export const AsideMain = styled.div`
  width: 90%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 80%;
  padding: 1rem 0;
  justify-content: space-evenly;
  align-items: center;
`;

export const AsideCard = styled.div`
  margin: 1rem 0;
  padding: 1rem 0;
  box-shadow: 0 0 10px -2px rgba(0, 0, 0, 0.5);
  flex: 1;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.23);
  cursor: pointer;

  & p {
    color: rgba(155, 155, 155);
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: center;
`;

export const CardTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 2;

  & h3 {
    width: 80%;
    padding: 0.5rem;
    color: rgba(155, 155, 155);
  }
`;

export const CardDesc = styled.div`
  width: 100%;
  flex: 2;
  margin: 1rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  & p {
    width: 80%;
    padding: 0.5rem;
    color: rgba(155, 155, 155);
  }
`;

export const CardFooter = styled.div`
  display: flex;
  flex: 6;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
`;

export const CardAdmin = styled.div`
  display: flex;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  background-color: black;
  align-items: center;
  justify-content: center;
`;

export const CardOptions = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0.5rem;
  height: 80%;
  justify-content: space-evenly;
  border-radius: 10px;
`;

export const CardStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 12px;
  margin: 8px;
  flex: 1;
  background-repeat: no-repeat;
  background-size: 100%;
  background-clip: padding-box;
  position: relative;
  color: #fff;
  transition: 0.5s;
  border-radius: 10px;
  background-image: linear-gradient(90deg, #7b81ec, #3bd1d3);
`;

export const AdminAvatar = styled.img`
  width: 30px;
  border-radius: 50%;
`;

export const AdminName = styled.div`
  margin: 0 0.7rem;
  & h4 {
    font-size: 0.9rem;
    color: #ddd;
  }
`;

export const PriorityCard = styled.div`
  border-radius: 10px;
  padding: 10px 12px;
  margin: 8px;
  flex: 1;
  border: none;
  color: #fff;
  background-clip: padding-box;
  background: ${(props) => (props.color ? props.color : "grey")};
`;

export const DottedIcon = styled(FaAngleDown)`
  cursor: pointer;
  font-size: 1.5rem;
  padding: 0 1.5rem;
  color: rgba(155, 155, 155);
`;

export const DashboardTitle = styled.div`
  display: flex;
  padding: 0.5rem 0;
  align-items: center;
  justify-content: center;
  width: 70%;

  @media screen and (max-width: 968px) {
    width: 100%;
  }

  & h3 {
    color: rgba(155, 155, 155);
  }
`;
